require('./lbaSearchBy.scss');

const $inject = [];
const lbaSearchBy = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaSearchByCtrl',
    controllerAs: 'vm',
    template: `
<div class="lbaSearchBy">
    <p>Search by:</p>
    <select ng-model="vm.searchTarget">
        <option ng-repeat="item in vm.settings.targetChoices">{{ item }}</option>
    </select>
    <input ng-model="vm.searchText" type="text">
    <button ng-click="vm.search(vm.searchText)" ng-disabled="vm.searchText.length < 2 || vm.searching">Search</button>
    <div class="lbaSearchBy_searching">
        <p ng-if="vm.searching">SEARCHING...</p>
        <p ng-if="!vm.searching">{{ vm.searchResults.length }} results.</p>
    </div>
    <ul>
        <li ng-repeat="item in vm.searchResults">
            <a ng-click="vm.loadResult(item.Id)">{{ item.Title }}</a>
        </li>
    </ul>
</div>`
  }
};

lbaSearchBy.$inject = $inject;

export default lbaSearchBy;


// WEBPACK FOOTER //
// ./src/components/lbaSearchBy/lbaSearchByDir.js